import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";
import { getApi } from '../../api/endpoints';
import Page from "../Page";
import FormPartial from "./FormPartial";
import PageContentWrapper from "../../components/PageContentWrapper";
import uiManager from '../../../config/ui.js';
import PAGES from '../../data/PagesConstants';
import ServiceCenter from '../../models/ServiceCenter';
import { toast } from 'react-toastify';

const New = () => {
  const [serviceCenter, setServiceCenter] = useState(new ServiceCenter());
  const [createApi] = getApi('createServiceCenter');
  const navigate = useNavigate();

  const createRecord = async (params) => {
    try {
      await createApi(params).unwrap();
      toast.success("Created Successful.");
      navigate("/service_centers")
    } catch(error) {
      let serviceCenterObj = new ServiceCenter(serviceCenter);
      serviceCenterObj.set_api_errors(error.data.data.errors);
      toast.error(JSON.stringify(error.data.data.errors) || "Something went wrong !");
    }
  }

  const onCreateClick = () => {
    try{
      createRecord((new ServiceCenter(serviceCenter)).toApiJson());
    } catch(error){
      setServiceCenter(new ServiceCenter(serviceCenter));
    }
  }

  const onBackClick = () => {
    navigate("/service_centers")
  }

  return <Page
    uiPage={uiManager.getUiPage(PAGES.NewServiceCenterPage.name)}
    breadcrumbs={[{ label: "Home", url: '/dashboard' }, { label: "Service Center", url: '/service_centers' }, { label: "Add Service Center" }]}
    className={'add-service-center-page'}
  >
    <PageContentWrapper contentHeading={"Add Service Center"}>
      <div className='m-3'>
        <form className="row g-4" autoComplete="off">
          <FormPartial serviceCenter={serviceCenter} setServiceCenter={setServiceCenter}/>
          <div className='mb-4 col-md-12'>
            <div>
              <button type="button" className="btn btn-voltup-theme" onClick={onBackClick} style={{ float: 'inline-start' }}>
                Back
              </button>
              <button type="button" className="btn btn-voltup-theme ms-3" onClick={onCreateClick}>
                Create Service Center
              </button>
            </div>
          </div>
        </form>
      </div>
    </PageContentWrapper>
  </Page>
};

export default New;
